<section class="availability-edit">
  <form [formGroup]="availabilityForm" (ngSubmit)="saveAvailableTime()">
    <div class="section">
      <label class="section-label">
        {{ 'contracts.valid-during' | translate }}
      </label>
      <div class="row">
        <span class="field">
          <small>{{ 'event.start' | translate }}</small>
          <app-datepicker-input
            [value]="availabilityForm.controls.availabilityStart.value"
            [includeTime]="true"
            (dateChange)="handleDateChange($event, 'startDate')"
            data-cy="datepicker-availabilty-start"
          ></app-datepicker-input>
        </span>
        <span class="field">
          <small>{{ 'event.end' | translate }}</small>
          <app-datepicker-input
            [value]="availabilityForm.controls.availabilityEnd.value"
            [includeTime]="true"
            (dateChange)="handleDateChange($event, 'endDate')"
            data-cy="datepicker-availabilty-end"
          ></app-datepicker-input>
        </span>
      </div>
    </div>

    <div class="section">
      <label class="section-label" for="description">
        {{ 'common.description' | translate }}
      </label>
      <textarea
        pTextarea
        id="description"
        [formControlName]="'description'"
        [rows]="3"
      ></textarea>
    </div>

    <div class="actions">
      <button
        pButton
        type="submit"
        class="p-button-primary"
        data-cy="availability-dialog-submit-btn"
      >
        {{ 'common.button.save' | translate }}
      </button>

      @if (userAvailability && userAvailability.id) {
        <button
          pButton
          type="button"
          class="p-button-danger"
          (click)="onDelete()"
        >
          {{ 'common.button.delete' | translate }}
        </button>
      }

      <button
        pButton
        type="button"
        class="p-button-secondary"
        (click)="doClose()"
      >
        {{ 'common.button.cancel' | translate }}
      </button>
    </div>
  </form>
</section>
